import { render, staticRenderFns } from "./ModuleMaterialTypesPage.vue?vue&type=template&id=242c0b3e&scoped=true"
import script from "./ModuleMaterialTypesPage.vue?vue&type=script&lang=js"
export * from "./ModuleMaterialTypesPage.vue?vue&type=script&lang=js"
import style0 from "./ModuleMaterialTypesPage.vue?vue&type=style&index=0&id=242c0b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c0b3e",
  null
  
)

export default component.exports